import { Base64 as JSBase64 } from 'js-base64';

export function encodeBase64(clearText: string) {
  return JSBase64.encode(clearText);
}

export function decodeBase64(b64: string) {
  return JSBase64.atob(b64);
}
